import image1 from '../../assets/programs/stem_mentorship/image1.webp'
import image_4 from '../../assets/programs/stem_mentorship/image_4.webp'
import image_5 from '../../assets/programs/stem_mentorship/image_5.webp'
import image_6 from '../../assets/programs/stem_mentorship/image_6.webp'
import image_7 from '../../assets/programs/stem_mentorship/image_7.webp'
import image8 from '../../assets/programs/stem_mentorship/image8.webp'
import image9 from '../../assets/programs/stem_mentorship/image9.webp'
import image10 from '../../assets/programs/stem_mentorship/image10.webp'
import image11 from '../../assets/programs/stem_mentorship/image11.webp'

const stem_mentorship_data = {
    "title": "MANASVI: STEM MENTORSHIP PROGRAMME",
    "description": "The STEM Mentorship Programme, inspires high school girls from Classes 9 and 11 to explore careers in STEM. Through expert lectures, lab demonstrations, and hands-on sessions, participants gain practical insights, including a Maker Space workshop for DIY projects.",
    "content": [
        {
            "primaryHeading": "",
            "subContent": [
                {
                    "secondaryHeading": "",
                    "description": "",
                    "images": [
                        {
                            "src": image1,
                            "desc": ""
                        },
                        {
                            "src": image_5,
                            "desc": ""
                        },
                        {
                            "src": image_6,
                            "desc": ""
                        },
                        {
                            "src": image_7,
                            "desc": ""
                        },
                        {
                            "src": image8,
                            "desc": ""
                        },
                        {
                            "src": image9,
                            "desc": ""
                        },
                        {
                            "src": image10,
                            "desc": ""
                        },
                        {
                            "src": image11,
                            "desc": ""
                        }
                    ]
                }
            ]
        }
    ]
}

export default stem_mentorship_data;